'use client';

import { type ReactNode, useEffect } from 'react';
import { registerExperimentVariants } from '@/app_lib/devdash/utils/experimentVariantsRegistry';
import { HideDateStampContext } from '@/app_lib/hooks/useHideDateStamp';
import { useOptimizely } from '@/main/lib/hooks/useOptimizely';
import type { VariantProps } from '@/main/lib/providers/OptimizelyProvider';

export const DateStampExperimentProvider = ({ children }: { children: ReactNode }) => {
  const { userFlags } = useOptimizely();
  const flag = userFlags.date_stamps as VariantProps | undefined;
  const hideDateStamps = Boolean(flag?.enabled) && flag?.variant === 'on';

  useEffect(() => {
    registerExperimentVariants('date_stamps', ['on', 'off']);
  }, []);

  return <HideDateStampContext.Provider value={hideDateStamps}>{children}</HideDateStampContext.Provider>;
};
